// custom.js
let G_currentVariant = null;

// 封装产品数据获取方法
function getProductDataAndMeta(context = document) {
    const productJsonElement = context.querySelector('[data-product-json]');
    const productMetaJsonElement = context.querySelector('[data-product-meta-json]');
    let productData = null;
    let productMetaData = null;
    let productMetaMap = {};

    if (productJsonElement) {
        try {
            productData = JSON.parse(productJsonElement.textContent);
            productData.variants = productData.variants;
            console.log('成功加载产品数据:', productData);
        } catch (e) {
            console.warn('产品 JSON 解析失败:', e);
        }
    } else {
        console.warn('未找到包含产品 JSON 数据的元素。');
    }

    if (productMetaJsonElement) {
        try {
            productMetaData = JSON.parse(productMetaJsonElement.textContent);
            productMetaData.forEach(item => {
                productMetaMap[item.id] = item.prodMeta;
            });
            console.log('成功加载产品元数据:', productMetaData);
        } catch (e) {
            console.warn('产品元数据 JSON 解析失败:', e);
        }
    }

    return { productData, productMetaData, productMetaMap };
}

// 变体切换处理方法，始终从全局缓存读取数据，避免作用域残留
function handleVariantChange(event, contextKey = 'main') {

    const cache = (typeof window !== 'undefined' && window.ProductContextCache && window.ProductContextCache[contextKey]) || {};
    const { productData, productMetaMap } = cache;
    console.log(productData, productMetaMap, cache);
    const subscriptionForm = document.querySelector('[data-subscription-form]');
    const subscribeStatus = subscriptionForm?.querySelector('[data-subscription-option]:checked')?.value;
    console.log('Selected subscription option:', subscribeStatus);
    const newVariant = event ? event.detail.variant : G_currentVariant;
    if (!newVariant) {
        console.log('变体切换事件中未提供新的变体信息。');
        return;
    }
    console.log('Handling variant change:', newVariant);
    if (!productData || !productData.variants) {
        console.warn(`[${contextKey}] 未获取到产品数据，无法渲染变体。`);
        return;
    }
    const breadcrumbsElement = document.querySelector('.breadcrumbs__current');
    // if (breadcrumbsElement) {
    //     if (newVariant.sku) {
    //         breadcrumbsElement.innerHTML = '';
    //     } else {
    //         breadcrumbsElement.innerHTML = '';
    //     }
    // }
    // if (newVariant.options.length <= 1) {
    //     return;
    // }
    const matchingVariants = productData.variants.filter(variant => {
        if (newVariant.options.length === 2) {
            return variant.option1 === newVariant.option1;
        } else if (newVariant.options.length === 3) {
            return variant.option1 === newVariant.option1 && variant.option2 === newVariant.option2;
        }
        else if (newVariant.options.length === 1) {
            return true;
        }
    });
    console.log('Matching variants:', matchingVariants);
    if (matchingVariants.length === 0) {
        document.querySelectorAll('.variant-item-quantity-price').forEach(el => el.innerHTML = '');
        document.querySelectorAll('.variant-item-quantity-price-per-num').forEach(el => el.innerHTML = '');
        document.querySelectorAll('.variant-item-quantity-price-per-flag').forEach(el => el.innerHTML = '');
        return;
    }
    let highestMatchingVariantUnitPrice = 0;
    matchingVariants.forEach(variant => {
        if (!variant.available) return;
        const quantity = parseFloat(variant.options[variant.options.length - 1]);
        if (!isNaN(quantity) && quantity > 0) {
            const unitPrice = variant.price / quantity;
            if (highestMatchingVariantUnitPrice < unitPrice) {
                highestMatchingVariantUnitPrice = unitPrice;
            }
        }
    });
    const variantItems = document.querySelectorAll('.variant-item-quantity-price');
    const variantPricePer = document.querySelectorAll('.variant-item-quantity-price-per-num');
    const variantPricePerFlag = document.querySelectorAll('.variant-item-quantity-price-per-flag');
    const variantOptionQuantity = document.querySelectorAll('.variant-option-quantity');
    variantOptionQuantity.forEach(el => {
        el.style.display = 'flex';
    });
    const priceData = getPriceForCurrentState();
    matchingVariants.forEach((variant, index) => {
        let matchVariantItem=null;
        let matchvariantPricePer = null;
        let matchvariantPricePerFlag = null;
        variantOptionQuantity.forEach(el => {
            let matchEl = null;
            console.log(el.querySelector('.variant-item-quantity-value').innerHTML)
            if (el.querySelector('.variant-item-quantity-value').innerHTML === variant.options[variant.options.length - 1]) {
                matchEl = el;
                matchVariantItem = el.querySelector('.variant-item-quantity-price');
                matchvariantPricePer = el.querySelector('.variant-item-quantity-price-per-num');
                matchvariantPricePerFlag = el.querySelector('.variant-item-quantity-price-per-flag');
            }
            console.log('matchEl', matchEl, variant.options[variant.options.length - 1]);

        });
        if (index < variantItems.length) {
            const quantity = parseFloat(variant.options[variant.options.length - 1]);
            const unitPrice = !isNaN(quantity) && quantity > 0 ? variant.price / quantity : 0;
            const measuringUnit = productMetaMap && productMetaMap[variant.id]?.measuring_unit_singular || 'unit';
            console.log('========================', subscribeStatus)
            if (subscribeStatus === 'subscribe') {
                matchVariantItem.innerHTML = '$' + (variant.price / 100 * (100 - priceData.discount.value) / 100).toFixed(2);
            }
            else {
                console.log('notSubscribe')
                matchVariantItem.innerHTML = '$' + (variant.price / 100).toFixed(2);

            }
            matchvariantPricePer.innerHTML = '￠' + unitPrice.toFixed(2) + ' per ' + measuringUnit;
            if (highestMatchingVariantUnitPrice > unitPrice && unitPrice > 0) {
                const percentageCheaper = Math.round(((highestMatchingVariantUnitPrice - unitPrice) / highestMatchingVariantUnitPrice) * 100);
                matchvariantPricePerFlag.innerHTML = percentageCheaper + '% cheaper in bulk!';
            } else {
                matchvariantPricePerFlag.innerHTML = '';
            }
        }
    });
    // matchingVariants.forEach((variant, index) => {
    //     if (!variant.available && index < variantOptionQuantity.length) {
    //         variantOptionQuantity[index].style.display = 'none';
    //     }
    // });
    // for (let i = matchingVariants.length; i < variantItems.length; i++) {
    //     variantItems[i].innerHTML = '';
    //     variantPricePer[i].innerHTML = '';
    //     variantPricePerFlag[i].innerHTML = '';
    // }
}

// 获取 URL 参数中的 variant id
function getVariantIdFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return params.get('variant');
}

// 自动渲染初始变体（优先 URL 参数中的 variant）
function renderInitialVariant(productData) {
    if (productData && productData.variants && productData.variants.length > 0) {
        let initialVariant = null;
        const variantIdFromUrl = getVariantIdFromUrl();
        if (variantIdFromUrl) {
            initialVariant = productData.variants.find(v => String(v.id) === String(variantIdFromUrl));
        }
        if (!initialVariant) {
            initialVariant = productData.variants[0];
        }
        if (initialVariant) {
            const event = new CustomEvent('product:variant-change', {
                detail: { variant: initialVariant }
            });
            document.dispatchEvent(event);
        } else {
            console.warn('未找到初始变体来触发渲染。');
        }
    }
}

function initializeSwatchHoverListeners() {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    document.querySelectorAll('.product-swatches-options__list').forEach(ul => {
        let originalImgSrc = null;
        let originalImgSrcset = null;
        let originalImgAlt = null;

        const swatches = ul.querySelectorAll('li');

        swatches.forEach(swatch => {
            if (!isMobile) {
                // PC端悬停预览
                swatch.addEventListener('mouseenter', function () {
                    const swatchImage = this.getAttribute('data-swatch-image');
                    const imgElement = this.closest('.product-item__inner')?.querySelector('.product-item__image--two img');
                    if (imgElement && swatchImage) {
                        if (originalImgSrc === null) {
                            originalImgSrc = imgElement.src;
                            originalImgSrcset = imgElement.srcset;
                            originalImgAlt = imgElement.alt;
                        }
                        let smallImg = swatchImage;
                        if (!/width=/.test(smallImg)) {
                            smallImg += (smallImg.includes('?') ? '&' : '?') + 'width=32';
                        }
                        imgElement.src = smallImg;
                        imgElement.srcset = smallImg + ' 1x, ' + swatchImage + ' 2x';
                        imgElement.alt = this.getAttribute('data-swatch-alt') || '';
                    }
                });
            }
            // 所有端点击切换主图和预览
            swatch.addEventListener('click', function () {
                console.log('Swatch clicked:', this);

                const parentList = this.closest('.product-swatches-options__list');
                if (parentList) {
                    parentList.querySelectorAll('li.is-selected').forEach(selected => {
                        selected.classList.remove('is-selected');
                    });
                }
                this.classList.add('is-selected');

                const swatchImage = this.getAttribute('data-swatch-image');
                let imgElement;
                if (isMobile) {
                    imgElement = this.closest('.product-item__inner')?.querySelector('.product-item__image--one img');
                } else {
                    imgElement = this.closest('.product-item__inner')?.querySelector('.product-item__image--two img');
                }
                if (imgElement && swatchImage) {
                    let smallImg = swatchImage;
                    if (!/width=/.test(smallImg)) {
                        smallImg += (smallImg.includes('?') ? '&' : '?') + 'width=32';
                    }
                    imgElement.src = smallImg;
                    imgElement.srcset = smallImg + ' 1x, ' + swatchImage + ' 2x';
                    imgElement.alt = this.getAttribute('data-swatch-alt') || '';
                    // 覆盖originalImgSrc为当前图片
                    originalImgSrc = imgElement.src;
                    originalImgSrcset = imgElement.srcset;
                    originalImgAlt = imgElement.alt;
                }
            });
        });

        ul.addEventListener('mouseleave', function () {
            const imgElement = this.closest('.product-item__inner')?.querySelector('.product-item__image--two img');
            if (imgElement && originalImgSrc) {
                imgElement.src = originalImgSrc;
                imgElement.srcset = originalImgSrcset || '';
                imgElement.alt = originalImgAlt || '';
            }
            originalImgSrc = null;
            originalImgSrcset = null;
            originalImgAlt = null;
        });
    });
}

function initializeModalScrollLock() {
    const quickProductModal = document.querySelector('[data-quick-product-modal]');
    if (quickProductModal) {
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const oldClassList = mutation.oldValue || '';
                    const newClassList = mutation.target.classList.toString();

                    const wasVisible = oldClassList.includes('is-visible');
                    const isVisible = newClassList.includes('is-visible');

                    if (wasVisible && !isVisible) {
                        // The modal was just closed, so we emit the close event
                        if (quickProductModal.dataset.quickProductType === 'quick-add') {
                            emit('quick-add:close');
                        } else if (quickProductModal.dataset.quickProductType === 'quick-view') {
                            emit('quick-view:close');
                        }
                    }
                }
            }
        });

        observer.observe(quickProductModal, {
            attributes: true,
            attributeOldValue: true
        });
    }

    let previousScrollY = 0;

    function lockBodyScroll() {
        previousScrollY = window.scrollY;
        document.documentElement.classList.add('modal-open');
        document.documentElement.style.marginTop = `-${previousScrollY}px`;
        document.documentElement.style.overflow = 'hidden';
        document.documentElement.style.left = '0';
        document.documentElement.style.right = '0';
        document.documentElement.style.top = '0';
        document.documentElement.style.bottom = '0';
        document.documentElement.style.position = 'fixed';
    }

    function unlockBodyScroll() {
        document.documentElement.classList.remove('modal-open');
        document.documentElement.style.marginTop = '';
        document.documentElement.style.overflow = '';
        document.documentElement.style.left = '';
        document.documentElement.style.right = '';
        document.documentElement.style.top = '';
        document.documentElement.style.bottom = '';
        document.documentElement.style.position = '';
        window.scrollTo(0, previousScrollY);
    }

    on('quick-add:open', function (state, data) {
        console.log('Quick add modal opened', data.productUrl);
        lockBodyScroll();

        fetchProductData(data.productUrl);
    });

    on('quick-add:close', function () {
        console.log('Quick add modal closed');
        unlockBodyScroll();
    });


    on('quick-view:open', function (state, data) {
        console.log('Quick view modal opened', data);
        lockBodyScroll();
        fetchProductData(data.productUrl);

    });

    on('quick-view:close', function () {
        console.log('Quick view modal closed');
        unlockBodyScroll();
    });
}
function fetchProductData(productUrl) {
    fetch(productUrl)
        .then(response => response.text())
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const { productData, productMetaData, productMetaMap } = getProductDataAndMeta(doc);

            if (typeof window !== 'undefined') {
                window.ProductContextCache = window.ProductContextCache || {};
                window.ProductContextCache['main'] = { productData, productMetaData, productMetaMap };
            }
            console.log(window.ProductContextCache['main']);
        })
        .catch(error => {
            console.error('Error fetching product data for quick add:', error);
        });
}
function formatMoney(cents, format) {
    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || window.theme.moneyFormat || '${{amount}}';

    function formatWithDelimiters(
        number,
        precision = 2,
        thousands = ',',
        decimal = '.'
    ) {
        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            `$1${thousands}`
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        default:
            value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
}

function getPriceForCurrentState() {
    const subscriptionForm = document.querySelector('[data-subscription-form]');
    if (!subscriptionForm || !G_currentVariant) return null;

    const selectedOption = subscriptionForm.querySelector('[data-subscription-option]:checked')?.value;

    if (selectedOption === 'subscribe') {
        const selectedPlanRadio = subscriptionForm.querySelector('[data-selling-plan-id]:checked');
        if (selectedPlanRadio) {
            const sellingPlanId = selectedPlanRadio.value;
            const allocation = G_currentVariant.selling_plan_allocations.find(a => a.selling_plan_id == sellingPlanId);
            if (allocation) {
                const plan = window.ProductContextCache.main.productData.selling_plan_groups[0].selling_plans.find(p => p.id == sellingPlanId);
                let discount = null;
                if (plan && plan.price_adjustments.length > 0) {
                    const adjustment = plan.price_adjustments[0];
                    if (adjustment.value_type === 'percentage') {
                        discount = {
                            type: 'percent_off',
                            value: adjustment.value
                        };
                    }
                }
                return {
                    price: allocation.price,
                    compare_at_price: allocation.compare_at_price,
                    discount: discount
                };
            }
        }
    }

    // Fallback to one-time purchase price
    return {
        price: G_currentVariant.price,
        compare_at_price: G_currentVariant.compare_at_price,
        discount: null
    };
}

function updateDisplayPrice() {
    const priceData = getPriceForCurrentState();
    if (!priceData) return;

    const productContainer = document.querySelector('[data-section-type="product"]');
    if (!productContainer) return;

    const priceElements = productContainer.querySelectorAll('.product__price [data-price], .sticky-atc-bar__price [data-price]');
    const comparePriceElements = productContainer.querySelectorAll('.product__price [data-compare-price], .sticky-atc-bar__price [data-compare-price]');
    const discountElements = productContainer.querySelectorAll('[data-discount-display]');

    priceElements.forEach(el => el.innerHTML = formatMoney(priceData.price));
    console.log(formatMoney(priceData.compare_at_price), formatMoney(priceData.price))
    console.log(priceElements, comparePriceElements)
    comparePriceElements.forEach(el => el.innerHTML = priceData.compare_at_price > priceData.price ? formatMoney(priceData.compare_at_price) : '');

    discountElements.forEach(el => {
        const badge = el.querySelector('.displayed-discount');
        if (priceData.discount && priceData.discount.type === 'percent_off') {
            let discountText = `${priceData.discount.value}% off`;

            if (badge) badge.textContent = discountText;
            el.dataset.hasDiscount = 'true';
        } else {
            if (badge) badge.textContent = '';
            el.dataset.hasDiscount = 'false';
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    // 初始化缓存
    const { productData, productMetaData, productMetaMap } = getProductDataAndMeta(document);
    console.log('Product data and meta initialized:', productData, productMetaData, productMetaMap);
    if (typeof window !== 'undefined') {
        window.ProductContextCache = window.ProductContextCache || {};
        window.ProductContextCache['main'] = { productData, productMetaData, productMetaMap };
    }

    document.addEventListener('product:variant-change', function (event) {
        G_currentVariant = event.detail.variant;
        handleVariantChange(event, 'main');
        setTimeout(() => {
            updateDisplayPrice();
        }, 200);
    });

    renderInitialVariant(productData);
    initializeSwatchHoverListeners();
    initializeModalScrollLock();
    initializeSubscriptionForm();
    initializeEnhancedVariantSystem();

});

function initializeSubscriptionForm() {
    const subscriptionForm = document.querySelector('[data-subscription-form]');
    if (!subscriptionForm) {
        return;
    }

    const sellingPlanInput = subscriptionForm.querySelector('input[name="selling_plan"]');
    const productForm = document.querySelector(`form[data-product-handle]`);

    if (productForm && sellingPlanInput) {
        productForm.appendChild(sellingPlanInput);
    }

    bindSubscriptionEvents(subscriptionForm, sellingPlanInput);
}

function bindSubscriptionEvents(subscriptionForm, sellingPlanInput) {
    const subscriptionOptions = subscriptionForm.querySelectorAll('[data-subscription-option]');
    const sellingPlanRadioButtons = subscriptionForm.querySelectorAll('[data-selling-plan-id]');

    function updateSellingPlan() {
        const selectedOption = subscriptionForm.querySelector('[data-subscription-option]:checked').value;

        if (selectedOption === 'subscribe') {
            const selectedPlan = subscriptionForm.querySelector('[data-selling-plan-id]:checked');
            if (selectedPlan) {
                sellingPlanInput.value = selectedPlan.value;
            }
        } else {
            sellingPlanInput.value = '';
        }
        updateDisplayPrice();
        handleVariantChange(null, contextKey = 'main')
    }

    subscriptionOptions.forEach(option => {
        option.addEventListener('change', updateSellingPlan);
    });

    sellingPlanRadioButtons.forEach(radio => {
        radio.addEventListener('change', updateSellingPlan);
    });

    // Initial state
    updateSellingPlan();
}

function enableDragToScroll(slider) {
    if (!slider) return;

    let isDown = false;
    let startX;
    let scrollLeft;
    let hasDragged = false;

    slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.style.cursor = 'grabbing';
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        hasDragged = false;
    });

    slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.style.cursor = 'grab';
    });

    slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.style.cursor = 'grab';
    });

    slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = x - startX;
        slider.scrollLeft = scrollLeft - walk;
        if (Math.abs(walk) > 3) {
            hasDragged = true;
        }
    });

    // Prevent click event on child elements after drag
    slider.addEventListener('click', (e) => {
        if (hasDragged) {
            e.preventDefault();
            e.stopPropagation();
        }
    }, true); // Use capture phase
}
let changeGridAutoRows = function (flexItems, flexInner) {
    let isItemHeightAuto = flexInner.getAttribute('data-is-item-height-auto') === 'true';
    let gridMode = flexInner.style.getPropertyValue('--grid-mode') || 'grid';
    if (!isItemHeightAuto) {
        console.log(gridMode, window.innerWidth);
        if (window.innerWidth < 900) {
            flexInner.style.gridAutoRows = `var(--item-height-mobile, 200px)`;
            if (gridMode === 'slider') {
                flexItems.forEach((flexItem) => {
                    flexItem.style.height = `var(--item-height-mobile, 200px)`;
                });
            } else {
                flexItems.forEach((flexItem) => {
                    flexItem.style.height = '';
                });
            }
        } else {
            flexInner.style.gridAutoRows = `var(--item-height, 200px)`;
            if (gridMode === 'slider') {
                flexItems.forEach((flexItem) => {
                    flexItem.style.height = `var(--item-height, 200px)`;
                });
            } else {
                flexItems.forEach((flexItem) => {
                    flexItem.style.height = '';
                });
            }
        }
        return;
    }
    let gridColumnNum = parseInt(flexInner.style.getPropertyValue('--grid-column-num')) || 4;
    let gridColumnNumMobile = parseInt(flexInner.style.getPropertyValue('--grid-column-num-mobile')) || 2;
    if (flexItems.length > 0) {
        let flexItem = flexItems[0];
        let percentageWidth = 0;
        if (window.innerWidth < 900) {
            percentageWidth =
                (flexInner.getBoundingClientRect().width - (gridColumnNumMobile - 1) * 16) / gridColumnNumMobile;
        } else {
            percentageWidth = (flexInner.getBoundingClientRect().width - (gridColumnNum - 1) * 16) / gridColumnNum;
        }

        flexInner.style.gridAutoRows = `${percentageWidth}px`;
        console.log('===============', percentageWidth)
    }
};

// Simple Enhanced Variant System - Minimal interference approach
function initializeSimpleVariantEnhancement() {
    console.log('Initializing simple variant enhancement');

    // Only add CSS for visual feedback - no JavaScript hiding
    addVariantStyles();

    // Set up event listeners first
    setupSimpleVariantHandlers();

    // Set up mutation observer to watch for disabled state changes
    setupVariantStateObserver();

    // Auto-select first available variant on load with multiple attempts
    let attempts = 0;
    const maxAttempts = 5;

    const tryAutoSelect = () => {
        attempts++;
        console.log(`Auto-selection attempt ${attempts}`);

        const optionGroups = document.querySelectorAll('.dynamic-variant-input-wrap');
        const variantButtons = document.querySelectorAll('.dynamic-variant-button');

        console.log(`Found ${optionGroups.length} option groups and ${variantButtons.length} variant buttons`);

        // Only proceed if we have variant elements
        if (optionGroups.length > 0 && variantButtons.length > 0) {
            autoSelectFirstVariant();

            // Check if auto-selection worked
            setTimeout(() => {
                const hasSelections = Array.from(optionGroups).some(group =>
                    group.querySelector('.dynamic-variant-button.selected') ||
                    group.querySelector('.dynamic-variant-input')?.value
                );

                console.log('Auto-selection check - has selections:', hasSelections);

                // If no selections were made and we haven't reached max attempts, try again
                if (!hasSelections && attempts < maxAttempts) {
                    console.log('No selections detected, retrying...');
                    setTimeout(tryAutoSelect, 300);
                } else if (hasSelections) {
                    console.log('Auto-selection successful');
                } else {
                    console.log('Auto-selection failed after', maxAttempts, 'attempts');
                }
            }, 200);
        } else if (attempts < maxAttempts) {
            // If elements not ready, try again
            console.log('Variant elements not ready, retrying...');
            setTimeout(tryAutoSelect, 300);
        }
    };

    // Start first attempt after a short delay
    setTimeout(tryAutoSelect, 300);
}

function addVariantStyles() {
    if (document.getElementById('simple-variant-styles')) return;

    const style = document.createElement('style');
    style.id = 'simple-variant-styles';
    style.textContent = `
        /* Hide disabled variant buttons completely */
        .dynamic-variant-button.disabled {
            display: none !important;
        }
        
        /* Ensure available buttons are always visible */
        .dynamic-variant-button:not(.disabled) {
            opacity: 1 !important;
            pointer-events: auto !important;
            cursor: pointer !important;
        }
    `;
    document.head.appendChild(style);
}

function autoSelectFirstVariant() {
    const optionGroups = document.querySelectorAll('.dynamic-variant-input-wrap');

    console.log('Auto-selecting first variant, found', optionGroups.length, 'option groups');

    optionGroups.forEach((group, index) => {
        // Skip if already has a valid selection
        const existingSelection = group.querySelector('.dynamic-variant-button.selected:not(.disabled)');
        const existingSelectValue = group.querySelector('.dynamic-variant-input')?.value;

        if (existingSelection || existingSelectValue) {
            console.log(`Group ${index + 1}: Already has selection, skipping`);
            return;
        }

        // Find first available button
        const availableButtons = group.querySelectorAll('.dynamic-variant-button:not(.disabled)');
        console.log(`Group ${index + 1}: Found ${availableButtons.length} available buttons`);

        if (availableButtons.length > 0) {
            const firstAvailable = availableButtons[0];
            console.log(`Group ${index + 1}: Auto-selecting button with value:`, firstAvailable.getAttribute('data-option-value'));

            // Use a more reliable click simulation
            firstAvailable.dispatchEvent(new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
            }));
            return;
        }

        // Find first available select option
        const select = group.querySelector('.dynamic-variant-input');
        if (select) {
            const availableOptions = Array.from(select.options).filter(option => !option.disabled && option.value);
            console.log(`Group ${index + 1}: Found ${availableOptions.length} available select options`);

            if (availableOptions.length > 0 && select.value !== availableOptions[0].value) {
                console.log(`Group ${index + 1}: Auto-selecting option:`, availableOptions[0].value);
                select.value = availableOptions[0].value;
                select.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    });
}

function setupSimpleVariantHandlers() {
    // Remove any existing listeners to avoid duplicates
    if (window.variantHandlersInitialized) {
        return;
    }
    window.variantHandlersInitialized = true;

    // Handle variant button clicks with more specific targeting
    document.addEventListener('click', function (e) {
        const variantButton = e.target.closest('.dynamic-variant-button');
        if (variantButton && !variantButton.classList.contains('disabled')) {
            console.log('Variant button clicked:', variantButton.getAttribute('data-option-value'));

            // Let the theme handle the click first, then auto-select next options
            // Use longer delay to ensure theme processing is complete
            setTimeout(() => {
                autoSelectNextOptions(variantButton);
            }, 150);
        }
    });

    // Handle variant select changes
    document.addEventListener('change', function (e) {
        const variantSelect = e.target.closest('.dynamic-variant-input');
        if (variantSelect) {
            console.log('Variant select changed:', variantSelect.value);

            // Let the theme handle the change first
            setTimeout(() => {
                autoSelectNextOptions(variantSelect);
            }, 150);
        }
    });

    // Also listen for theme's variant change events to trigger auto-selection
    document.addEventListener('product:variant-change', function (e) {
        console.log('Product variant changed event detected');
        setTimeout(() => {
            // Comprehensive check for all groups that need auto-selection
            const optionGroups = document.querySelectorAll('.dynamic-variant-input-wrap');
            let needsAutoSelection = false;

            optionGroups.forEach((group, index) => {
                const selectedButton = group.querySelector('.dynamic-variant-button.selected');
                const select = group.querySelector('.dynamic-variant-input');

                // Check if selection is invalid or missing
                const hasDisabledSelection = selectedButton?.classList.contains('disabled');
                const hasDisabledSelectOption = select && select.selectedIndex > 0 && select.options[select.selectedIndex]?.disabled;
                const hasNoSelection = !selectedButton && (!select || !select.value);

                if (hasDisabledSelection || hasDisabledSelectOption || hasNoSelection) {
                    console.log(`Group ${index + 1} needs auto-selection:`, {
                        hasDisabledSelection,
                        hasDisabledSelectOption,
                        hasNoSelection
                    });
                    needsAutoSelection = true;
                }
            });

            if (needsAutoSelection) {
                console.log('Triggering comprehensive auto-selection');
                autoSelectAllAvailableOptions();
            }
        }, 150); // Longer delay to ensure theme has processed the change
    });
}

// New function to auto-select available options in all groups
function autoSelectAllAvailableOptions() {
    const optionGroups = document.querySelectorAll('.dynamic-variant-input-wrap');

    optionGroups.forEach((group, index) => {
        const selectedButton = group.querySelector('.dynamic-variant-button.selected');
        const select = group.querySelector('.dynamic-variant-input');

        // Check if current selection is valid
        const hasValidSelection = (selectedButton && !selectedButton.classList.contains('disabled')) ||
            (select && select.value && select.selectedIndex > 0 && !select.options[select.selectedIndex]?.disabled);

        if (!hasValidSelection) {
            console.log(`Group ${index + 1}: Selecting first available option`);

            // Clear any invalid selection first
            if (selectedButton && selectedButton.classList.contains('disabled')) {
                selectedButton.classList.remove('selected');
            }

            // Find and select first available option
            const availableButtons = group.querySelectorAll('.dynamic-variant-button:not(.disabled)');
            if (availableButtons.length > 0) {
                const firstAvailable = availableButtons[0];
                console.log(`Group ${index + 1}: Selecting button:`, firstAvailable.getAttribute('data-option-value'));

                firstAvailable.dispatchEvent(new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true,
                    view: window
                }));
            } else if (select) {
                const availableOptions = Array.from(select.options).filter(option => !option.disabled && option.value);
                if (availableOptions.length > 0) {
                    console.log(`Group ${index + 1}: Selecting option:`, availableOptions[0].value);
                    select.value = availableOptions[0].value;
                    select.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        }
    });
}

// Add mutation observer to watch for disabled state changes
function setupVariantStateObserver() {
    const observer = new MutationObserver((mutations) => {
        let hasDisabledStateChange = false;

        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' &&
                mutation.attributeName === 'class' &&
                mutation.target.classList.contains('dynamic-variant-button')) {

                const wasDisabled = mutation.oldValue?.includes('disabled');
                const isDisabled = mutation.target.classList.contains('disabled');

                if (wasDisabled !== isDisabled) {
                    hasDisabledStateChange = true;
                }
            }
        });

        if (hasDisabledStateChange) {
            console.log('Variant disabled states changed, checking for auto-selection needs');
            setTimeout(() => {
                autoSelectAllAvailableOptions();
            }, 50);
        }
    });

    // Observe the variant wrapper
    const variantWrapper = document.querySelector('.product__variants-wrapper');
    if (variantWrapper) {
        observer.observe(variantWrapper, {
            attributes: true,
            subtree: true,
            attributeFilter: ['class'],
            attributeOldValue: true
        });
    }
}

function autoSelectNextOptions(changedElement) {
    const optionGroups = document.querySelectorAll('.dynamic-variant-input-wrap');
    const changedGroup = changedElement.closest('.dynamic-variant-input-wrap');
    const changedIndex = Array.from(optionGroups).indexOf(changedGroup);

    console.log('Auto-selecting options after change in group:', changedIndex + 1);

    // Wait a bit for the theme to update disabled states
    setTimeout(() => {
        // Check ALL groups for invalid selections and auto-select first available
        optionGroups.forEach((group, index) => {
            // Skip the group that just changed
            if (index === changedIndex) {
                return;
            }

            const selectedButton = group.querySelector('.dynamic-variant-button.selected');
            const select = group.querySelector('.dynamic-variant-input');

            // Check if current selection is now disabled
            const currentSelectionInvalid = selectedButton?.classList.contains('disabled') ||
                (select && select.selectedIndex > 0 && select.options[select.selectedIndex]?.disabled);

            // Check if there's no selection at all
            const hasNoSelection = !selectedButton && (!select || !select.value);

            console.log(`Group ${index + 1}: Current selection invalid:`, currentSelectionInvalid, 'Has no selection:', hasNoSelection);

            if (currentSelectionInvalid || hasNoSelection) {
                // Find first available option
                const availableButtons = group.querySelectorAll('.dynamic-variant-button:not(.disabled)');

                if (availableButtons.length > 0) {
                    const firstAvailable = availableButtons[0];
                    console.log(`Group ${index + 1}: Auto-selecting available button:`, firstAvailable.getAttribute('data-option-value'));

                    // Clear current selection first
                    if (selectedButton) {
                        selectedButton.classList.remove('selected');
                    }

                    // Select new option
                    firstAvailable.dispatchEvent(new MouseEvent('click', {
                        bubbles: true,
                        cancelable: true,
                        view: window
                    }));
                } else if (select) {
                    const availableOptions = Array.from(select.options).filter(option => !option.disabled && option.value);
                    if (availableOptions.length > 0) {
                        console.log(`Group ${index + 1}: Auto-selecting available option:`, availableOptions[0].value);
                        select.value = availableOptions[0].value;
                        select.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
            }
        });
    }, 100); // Give theme time to update disabled states
}

// Initialize the simple variant enhancement system
function initializeEnhancedVariantSystem() {
    // Wait for theme to be ready, then initialize our simple enhancement
    setTimeout(() => {
        initializeSimpleVariantEnhancement();

        // Also handle modals
        document.addEventListener('quick-view:open', function () {
            setTimeout(() => initializeSimpleVariantEnhancement(), 300);
        });

        document.addEventListener('quick-add:open', function () {
            setTimeout(() => initializeSimpleVariantEnhancement(), 300);
        });
    }, 500);
}